import { GraphColors, SeverityColors, deviceLabels } from '@utils/aiAlerts/mapping';

export const allExceptAnamolyGraphOption = (data) => ({
  name: 'All except anomaly',
  seriesType: 'ai-alert-timeseries',
  itemStyle: { color: GraphColors.exceptAnamoly },
  lineStyle: {
    type: 'solid',
    width: 1.5,
  },
  showSymbol: false,
  type: 'line',
  data,
});

export const pcpGraphOption = (data, name) => ({
  name,
  seriesType: 'ai-alert-pcp',
  yAxisIndex: 2,
  type: 'bar',
  tooltip: {
    valueFormatter(value) {
      return value;
    },
  },
  itemStyle: {
    color: GraphColors.pcpDrop,
    borderColor: GraphColors.pcpDropBorder,
  },
  data,
});

export const baselineGraphOption = (data) => ({
  name: 'Baseline',
  seriesType: 'ai-alert-baseline',
  itemStyle: {
    color: GraphColors.baseline,
  },
  lineStyle: {
    type: 'dashed',
    width: 1.5,
  },
  showSymbol: false,
  type: 'line',
  data,
});

export const projectedLineGraphOption = (data) => ({
  name: 'Projected',
  seriesType: 'ai-alert-baseline',
  itemStyle: {
    color: GraphColors.baseline,
  },
  lineStyle: {
    type: 'dashed',
    width: 1.5,
  },
  showSymbol: false,
  type: 'line',
  data,
});

export const t7GraphLineOption = (data) => ({
  name: 'T-7',
  seriesType: 'ai-alert-tMinus7',
  itemStyle: {
    color: GraphColors.threshold,
  },
  lineStyle: {
    width: 1.5,
    type: 'dashed',
  },
  showSymbol: false,
  type: 'line',
  data,
});

export const thresholdGraphLineOption = (data) => ({
  name: 'Threshold',
  seriesType: 'ai-alert-threshold',
  itemStyle: {
    color: GraphColors.threshold,
  },
  lineStyle: {
    width: 1.5,
    type: 'dashed',
  },
  showSymbol: false,
  type: 'line',
  data,
});

export const brushLineSeverityData = (timestamp) => ({
  type: 'time',
  xAxis: timestamp,
  name: 'Issue Started',
  label: {
    formatter: 'Issue Started',
    position: 'end',
    show: false,
  },
  lineStyle: {
    width: 1,
    type: 'dashed',
  },
  itemStyle: { color: SeverityColors.Ended },
});

export const severityBrushLineOption = (data) => ({
  symbol: ['none', 'rect'],
  lineStyle: { width: 1, type: 'solid' },
  data,
});

export const tooltipPosition = (point, params, dom, rect, size) => {
  const obj = { top: 20 };

  const GAP = 20;
  const x = point[0];
  if (x + size.contentSize[0] + GAP < size.viewSize[0]) {
    obj.left = x + 20;
  } else {
    obj.left = 'auto';
    obj.right = size.viewSize[0] - x + 20;
  }

  return obj;
};

export const pcpDropYAxis = {
  type: 'value',
  name: ' ',
  min: 0,
  max: 100,
  interval: 50,
  axisLabel: {
    formatter: '{value} %',
    show: false,
  },
};

export const getDeviceSeriesOption = (id, data) => ({
  id,
  name: deviceLabels[id],
  lineStyle: { type: 'solid', width: 1.5 },
  type: 'line',
  data,
  //TODO: axis index should be assigned while the series
  xAxisIndex: 0,
  yAxisIndex: 1,
});

export default tooltipPosition;
